import { ContentWithAside } from "layouts/kiosk-h"

import { themeOptionFactories } from "./theme"

import { EmServiceKioskHPage } from "./pages/em-service/index.kiosk"

import { EmServiceMobilePage } from "./pages/em-service"

export const emService = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "service",
        element: <EmServiceMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "service",
        element: <EmServiceKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
